import React, { useState, useRef, useEffect } from 'react';
import { FaTerminal, FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Terminal.module.css';

const Terminal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [history, setHistory] = useState([
    { type: 'output', content: 'Welcome to PrinceOS v1.0.0' },
    { type: 'output', content: 'Type "help" to see available commands.' }
  ]);
  const inputRef = useRef(null);
  const bottomRef = useRef(null);

  // Auto-scroll to bottom
  useEffect(() => {
    if (bottomRef.current) bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [history, isOpen]);

  // Focus input on click
  useEffect(() => {
    if (isOpen && inputRef.current) inputRef.current.focus();
  }, [isOpen]);

  const handleCommand = (e) => {
    if (e.key === 'Enter') {
      const cmd = input.trim().toLowerCase();
      let response = '';

      switch (cmd) {
        case 'help':
          response = 'Available commands: about, projects, skills, contact, clear, exit';
          break;
        case 'about':
          response = 'Prince Desai. Full Stack Dev & AI Enthusiast.';
          break;
        case 'projects':
          response = 'Loaded: Docu-Flow, HighQ Classes, Resumia AI... (Check UI for details)';
          break;
        case 'skills':
          response = 'Core: React, Node.js, Python, Agentic AI, AWS, Jugaad.';
          break;
        case 'contact':
          response = 'Email: ppatel3735@gmail.com | GitHub: @princedesai012';
          break;
        case 'clear':
          setHistory([]);
          setInput('');
          return;
        case 'exit':
          setIsOpen(false);
          setInput('');
          return;
        default:
          response = `Command not found: ${cmd}. Type "help" for list.`;
      }

      setHistory([
        ...history, 
        { type: 'command', content: cmd },
        { type: 'output', content: response }
      ]);
      setInput('');
    }
  };

  return (
    <>
      {/* Floating Toggle Button */}
      {!isOpen && (
        <motion.button 
          className={styles.floatBtn}
          onClick={() => setIsOpen(true)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaTerminal />
        </motion.button>
      )}

      {/* Terminal Window */}
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            className={styles.overlay}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
          >
            <div className={`${styles.terminalWindow} glass`}>
              <div className={styles.header}>
                <span className={styles.dotRed} onClick={() => setIsOpen(false)}></span>
                <span className={styles.dotYellow}></span>
                <span className={styles.dotGreen}></span>
                <span className={styles.title}>guest@prince-portfolio:~</span>
                <FaTimes className={styles.closeIcon} onClick={() => setIsOpen(false)} />
              </div>
              
              <div className={styles.body} onClick={() => inputRef.current.focus()}>
                {history.map((line, i) => (
                  <div key={i} className={line.type === 'command' ? styles.commandLine : styles.outputLine}>
                    {line.type === 'command' ? <span className={styles.prompt}>➜ ~</span> : ''} {line.content}
                  </div>
                ))}
                
                <div className={styles.inputLine}>
                  <span className={styles.prompt}>➜ ~</span>
                  <input 
                    ref={inputRef}
                    type="text" 
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={handleCommand}
                    className={styles.input}
                    autoFocus
                  />
                </div>
                <div ref={bottomRef}></div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Terminal;